import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import selectors from './selectors';
import operations from './operations';

const options = {
  name: 'groups',
  baseType: 'GROUPS',
  apiEndpoint: 'groups'
};

export { operations, selectors };
export default createMetadataAPIReducer(options);
